export const SLONIK_MODULE_OPTIONS = 'SlonikModuleOptions';
export const SLONIK_MODULE_ID = 'SlonikModuleId';
export const DEFAULT_POOL_NAME = 'default';
